/**
 * Attorney directory drawer filters.
 * yes/no fields use "" | "yes" | "no".
 */
export type AttorneysFiltersState = {
  practiceArea: string;
  emailDomain: string;
  hasCompany: string;
};

export const EMPTY_ATTORNEYS_FILTERS: AttorneysFiltersState = {
  practiceArea: "",
  emailDomain: "",
  hasCompany: "",
};

export const YES_NO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
] as const;

export const FILTER_FIELD_LABELS: Record<keyof AttorneysFiltersState, string> = {
  practiceArea: "Practice area",
  emailDomain: "Email domain",
  hasCompany: "Has company",
};
